import { classNames } from "primereact/utils";
import { BodyMetricTypeLabels } from "../../../../labels";
import { dateUtility } from "../../../../infrastructure/utilities/dateUtility";
import { RenderWhen } from "../../../../infrastructure/components/RenderWhen";
import { BodyMetricIcon } from "../../BodyMetricIcon/BodyMetricIcon";
import { IBodyMetricSummary } from "../../models/bodyMetricModels";
import { BODY_METRIC_TYPES } from "../../models/bodyMetricTypes";
import {
  formatBodyMetricChange,
  formatBodyMetricNumber,
} from "../../utils/bodyMetricsUtility";
import { BodyMetricSparkline } from "./BodyMetricSparkline";
import styles from "./BodyMetricCard.module.scss";

interface IBodyMetricCardProps {
  summary: IBodyMetricSummary;
  onClick: () => void;
}

/** One metric on the overview: its latest value, the last change and a trend line. */
export const BodyMetricCard = ({ summary, onClick }: IBodyMetricCardProps) => {
  const { type, latest, change, history } = summary;
  const config = BODY_METRIC_TYPES[type];

  return (
    <button
      type="button"
      className={classNames(styles.root, styles[`root_${config.group}`])}
      onClick={onClick}
      aria-label={`${BodyMetricTypeLabels[type]}: ${formatBodyMetricNumber(type, latest.value)} ${config.unit}`}
    >
      <div className={styles.root_head}>
        <span className={styles.root_orb}>
          <BodyMetricIcon type={type} size={20} />
        </span>
        <span className={styles.root_label}>{BodyMetricTypeLabels[type]}</span>
      </div>

      <div className={styles.root_value}>
        {formatBodyMetricNumber(type, latest.value)}
        <span className={styles.root_value_unit}>{config.unit}</span>
      </div>

      <div className={styles.root_meta}>
        <RenderWhen condition={change !== null}>
          <span
            className={classNames(styles.root_change, {
              [styles.root_change_up]: (change ?? 0) > 0,
              [styles.root_change_down]: (change ?? 0) < 0,
            })}
          >
            {change !== null ? formatBodyMetricChange(type, change) : ""}
          </span>
        </RenderWhen>
        <span className={styles.root_date}>{dateUtility.formatDate(latest.measuredOn)}</span>
      </div>

      <BodyMetricSparkline history={history} />
    </button>
  );
};
